import { INewRelic } from '../../../typings/window'
import MvFetch from '../../helpers/mvFetch'
import Logger from '../../helpers/Logger'
import { getRoll } from '../../helpers/random'

const batchTime = 3000 // ms
const startTime = Date.now()
const config = {
  beacon: 'bam.nr-data.net',
  errorBeacon: 'bam.nr-data.net',
  licenseKey: '826b256fb3',
  applicationID: '21735165',
  sa: 1
}

class NewRelicAdapter implements INewRelic {
  readonly info = config
  private actions: Array<IPageAction> = []
  private customAttributes = {}
  private disable = window.$mediavine.web.model.disable_newrelic
  private samplingRate = window.$mediavine.web.model.samplingRate || 10

  constructor() {
    setInterval(() => this.sendBatch(), batchTime)
    window.addEventListener('pagehide', () => this.sendBatch())
    window.$mediavine.newrelic = window.$mediavine.newrelic || this
    this.addPageAction = this.addPageAction.bind(this)
    this.setCustomAttribute = this.setCustomAttribute.bind(this)
  }

  addPageAction(actionName: string, data: object): void {
    if (!takeSample(this.samplingRate)) {
      return
    }
    // Normalize values to strings, no arrays or objects
    Object.keys(data).forEach(
      (key) => (data[key] = convertValuesToPrimitives(data[key]))
    )

    const timestamp = Date.now()
    const pageAction: IPageAction = {
      actionName,
      timestamp,
      timeSinceLoad: (timestamp - startTime) / 1e3,
      browserWidth: window.document.documentElement.clientWidth,
      browserHeight: window.document.documentElement.clientHeight,
      eventType: 'PageAction',
      referrerUrl: document.referrer,
      currentUrl: document.location + '',
      pageUrl: document.location.origin,
      ...this.customAttributes,
      ...data
    }

    this.actions.push(pageAction)
  }

  setErrorHandler(callback: (error: Error) => boolean): void {}

  setCustomAttribute(name: string, value: string | number): void {
    this.customAttributes[name] = value
  }

  private sendBatch() {
    if (this.actions.length === 0 || this.disable) {
      return
    }
    const payload = getNewRelicPayload(this.actions)
    sendToNewRelic(JSON.stringify(payload))
    this.actions = []
  }
}

export const getNewRelicUrl = (config, time = startTime): string => {
  const timeElapsed = Date.now() - time
  return `https://${config.beacon}/ins/1/${config.licenseKey}?a=${config.applicationID}&sa=1&v=1158.afc605b&t=Unnamed%20Transaction&rst=${timeElapsed}&ref=${document.URL}`
}

export const sendToNewRelic = async (payload: any) => {
  try {
    await MvFetch.fetch(getNewRelicUrl(config), 'POST', payload)
  } catch (e) {
    Logger.debug(e)
  }
}

export const convertValuesToPrimitives = (val) =>
  val && typeof val === 'object' ? JSON.stringify(val) : val

export const getNewRelicPayload = (actions: Array<IPageAction>) => ({
  ins: [...actions]
})

type IPageAction = {
  [key: string]: any
  actionName: string
  timestamp: number
  eventType: 'PageAction'
}

export const newRelicAdapter = new NewRelicAdapter()

function takeSample(rate: number): boolean {
  const entropyValue = 100
  const possibleOutcomes = 100 * entropyValue
  return getRoll(possibleOutcomes) < possibleOutcomes * rate
}
